import { action, observable } from 'mobx'

import Ds from './ds'

class Tasks {
  @observable all = []
  @observable data = []
  @observable task = []
  @observable pending = []
  @observable pendingpartner = []
  @observable postponed = []
  @observable completed = []
  @observable completedpartner = []
  @observable taskStates = []
  @observable taskPriorities = []
  @observable new = []
  @observable details = {}

  @observable ds = new Ds()

  @action loadAllTaskPriorities() {
    let query = `{
      taskPriorities(
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        name
      }
    }`

    //console.log(query)

    this.ds.query(query, (data) => {
      this.taskPriorities = data.taskPriorities
      //console.log(data.taskPriorities)
    })
  }

  @action loadAllTasks() {
    let query = `{
      tasks(
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        companyId
        task
        dueDate
        company {
          name
          defaultBillingAddress {
            city
            state
          }
        }
        taskPriorityId
        taskPriority {
          name
        }
        taskState {
          name
        }
        user {
          firstName
          lastName
        }
        createdAt
      }
    }`
    //console.log(query)

    this.ds.query(query, (data) => {
      this.all = data.tasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        if (task.company != null) {
          task.fullAddress = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          task.companyName = task.company.name
        }
        task.userFullName = task.user.firstName + ' ' + task.user.lastName
        task.priority = task.taskPriority.name
        task.state = task.taskState.name
        return task
      })
    })
  }

  @action loadAllNewlyAssignedTasks(callback) {
    let query = ''

    query = `{
      tasks(hash: "${ localStorage.getItem('userHash') }", newAssigned: 1, assignedUserId: ${ localStorage.getItem('userId') }) {
        id
        companyId
        company {
          name
          vendor {
            name
          }
          defaultBillingAddress {
            city
            state
          }
        }
        task 
        dueDate 
        taskPriorityId
        taskPriority {
          name
        }
        userId 
        user {
          firstName
          lastName
        }
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        createdAt 
      } 
    }`

    console.log(query)
    this.ds.query(query, (data) => {
      this.new = data.tasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        
        if (task.company) {
          task.companyName = task.company.name

          if (task.company.vendor) {
            task.vendorName = task.company.vendor.name
          } else {
            task.vendorName = 'No Vendor'
          }

          if (task.company.source) {
            task.sourceName = task.company.source.name
          } else {
            task.sourceName = ''
          }

          if (task.company.defaultBillingAddress) {
            task.location = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          } else {
            task.locaion = ''
          }

        } else {
          task.companyName = 'ORPHANED TASK. DELETE!'
          task.vendorName = 'No Vendor'
          task.locaion = ''       
        }        
        
        if (task.user) {
          task.userName = task.user.firstName + ' ' + task.user.lastName
        } else {
          task.userName = ''
        }

        if (task.assignedUser) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }

        if (task.taskPriority) {
          task.taskPriorityName = task.taskPriority.name
        } else {
          task.taskPriorityName = ''
        }

        return task
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllPendingTasks(callback) {
    let query = ''

    if ( localStorage.getItem('userAccessLevel') >= 15 ) {
      query = `{
        tasks(hash: "${ localStorage.getItem('userHash') }", taskStateId: 1) {
          id
          companyId
          company {
            name
            vendor {
              name
            }
            defaultBillingAddress {
              city
              state
            }
          }
          task 
          dueDate 
          taskPriorityId
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    } else {
      query = `{ 
        tasks(assignedUserId: ${ localStorage.getItem('userId') }, hash: "${ localStorage.getItem('userHash') }", taskStateId: 1) { 
          id 
          companyId 
          company {
            name
            vendor {
              name
            }
            defaultBillingAddress {
              city
              state
            }
          }
          task 
          dueDate 
          taskPriorityId
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.pending = data.tasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        
        if (task.company) {
          task.companyName = task.company.name

          if (task.company.vendor) {
            task.vendorName = task.company.vendor.name
          } else {
            task.vendorName = 'No Vendor'
          }

          if (task.company.source) {
            task.sourceName = task.company.source.name
          } else {
            task.sourceName = ''
          }

          if (task.company.defaultBillingAddress) {
            task.location = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          } else {
            task.locaion = ''
          }

        } else {
          task.companyName = 'ORPHANED TASK. DELETE!'
          task.vendorName = 'No Vendor'
          task.locaion = ''       
        }        
        
        if (task.user) {
          task.userName = task.user.firstName + ' ' + task.user.lastName
        } else {
          task.userName = ''
        }

        if (task.assignedUser) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }

        if (task.taskPriority) {
          task.taskPriorityName = task.taskPriority.name
        }

        return task
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllPendingPartnerTasks(callback) {
    let query = ''

    if ( localStorage.getItem('userAccessLevel') >= 15 ) {
      query = `{ 
        partnerTasks( hash: "${ localStorage.getItem('userHash') }", taskStateId: 1 ) { 
          id 
          partnerId 
          task 
          dueDate 
          partner { 
            firstName 
            lastName 
            phone
            email
          } 
          taskPriorityId 
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    } else {
      query = `{ 
        partnerTasks( assignedUserId: ${ localStorage.getItem('userId') }, hash: "${ localStorage.getItem('userHash') }", taskStateId: 1 ) { 
          id 
          partnerId 
          task 
          dueDate 
          partner { 
            firstName 
            lastName 
            phone
            email
          } 
          taskPriorityId 
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.pendingpartner = data.partnerTasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        
        if (task.partner != null) {
          task.partnerEmail = task.partner.email
          task.partnerPhone = task.partner.phone
          task.partnerName = task.partner.firstName + ' ' + task.partner.lastName
        }
        
        if (task.user) {
          task.userName = task.user.firstName + ' ' + task.user.lastName
        } else {
          task.userName = ''
        }

        if (task.assignedUser) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }

        if (task.taskPriority) {
          task.taskPriorityName = task.taskPriority.name
        } else {
          task.taskPriorityName = ''
        }

        return task
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllCompletedTasks(callback) {
    let query = ''

    if ( localStorage.getItem('userAccessLevel') >= 15 ) {
      query = `{ 
        tasks( hash: "${ localStorage.getItem('userHash') }", taskStateId: 2 ) { 
          id
          companyId
          company {
            name
            vendor {
              name
            }
            source {
              name
            }
            defaultBillingAddress {
              city
              state
            }
          }
          task 
          dueDate 
          taskPriorityId
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    } else {
      query = `{ 
        tasks( assignedUserId: ${ localStorage.getItem('userId') }, hash: "${ localStorage.getItem('userHash') }", taskStateId: 2 ) { 
          id
          companyId
          company {
            name
            vendor {
              name
            }
            source {
              name
            }
            defaultBillingAddress {
              city
              state
            }
          }
          task 
          dueDate 
          taskPriorityId
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.completed = data.tasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        
        if (task.company) {
          task.companyName = task.company.name

          if (task.company.vendor) {
            task.vendorName = task.company.vendor.name
          } else {
            task.vendorName = 'No Vendor'
          }

          if (task.company.source) {
            task.sourceName = task.company.source.name
          } else {
            task.sourceName = ''
          }
          
          if (task.company.defaultBillingAddress) {
            task.location = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          } else {
            task.locaion = ''
          }

        } else {
          task.companyName = 'ORPHANED TASK. DELETE!'
          task.vendorName = 'No Vendor'
          task.locaion = ''       
        } 

        if (task.user) {
          task.userName = task.user.firstName + ' ' + task.user.lastName
        } else {
          task.userName = ''
        }

        if (task.assignedUser) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }

        if (task.taskPriority) {
          task.taskPriorityName = task.taskPriority.name
        }

        return task
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllCompletedPartnerTasks(callback) {
    let query = ''

    if ( localStorage.getItem('userAccessLevel') >= 15 ) {
      query = `{ 
        partnerTasks( hash: "${ localStorage.getItem('userHash') }", taskStateId: 2 ) { 
          id 
          partnerId 
          task 
          dueDate 
          partner { 
            firstName 
            lastName 
            phone
            email
          } 
          taskPriorityId 
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt 
        } 
      }`
    } else {
      query = `{ 
        partnerTasks( assignedUserId: ${ localStorage.getItem('userId') }, hash: "${ localStorage.getItem('userHash') }", taskStateId: 2 ) { 
          id 
          partnerId 
          task 
          dueDate 
          partner { 
            firstName 
            lastName 
            phone
            email
          } 
          taskPriorityId 
          taskPriority {
            name
          }
          userId 
          user {
            firstName
            lastName
          }
          assignedUserId
          assignedUser {
            firstName
            lastName
          }
          createdAt  
        } 
      }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.completedpartner = data.partnerTasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        if (task.partner != null) {
          task.partnerEmail = task.partner.email
          task.partnerPhone = task.partner.phone
          task.partnerName = task.partner.firstName + ' ' + task.partner.lastName
        }
        
        if (task.user) {
          task.userName = task.user.firstName + ' ' + task.user.lastName
        } else {
          task.userName = ''
        }

        if (task.assignedUser) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }

        if (task.taskPriority) {
          task.taskPriorityName = task.taskPriority.name
        } else {
          task.taskPriorityName = ''
        }

        return task
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllPostponedTasks() {
    let query = `{
      tasks(
        hash: "${ localStorage.getItem('userHash') }",
        taskStateId: 3
      ) {
        id
        companyId
        task
        dueDate
        company {
          name
          defaultBillingAddress {
            city
            state
          }
        }
        taskPriorityId
        user {
          firstName
          lastName
        }
        createdAt
      }
    }`
    //console.log(query)

    this.ds.query(query, (data) => {
      this.postponed = data.tasks.map((task) => {
        let dd = new Date(task.dueDate)
        task.formattedDueDate =   ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate =   ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        if (task.company != null) {
          task.fullAddress = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          task.companyName = task.company.name
        }
        task.userFullName = task.user.firstName + ' ' + task.user.lastName
        //task.priority = task.taskPriority.name
        return task
      })
    })
  }

  @action loadTask(id, callback) {
    let query = `{
      tasks(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        userId
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        task
        dueDate
        taskPriorityId
        taskPriority {
          name
        }
        taskStateId
        taskState {
          name
        }
        companyId
        company {
          defaultContact{
            email
            phone
          }
        }
      }
    }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (data.tasks.length > 0) {

        let task = data.tasks[0]

        this.task = task
        callback(task)
      } else {
        console.log('Nothing from query')
      }
    })
  }

  @action loadPartnerTask(id, callback) {
    let query = `{
      partnerTasks(
        id: ${ id },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        userId
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        task
        dueDate
        taskPriorityId
        taskPriority {
          name
        }
        taskStateId
        taskState {
          name
        }
        partner {
          firstName
          lastName
          phone
          email
        }
      }
    }`
    //console.log(query)
    this.ds.query(query, (data) => {
      if (data.partnerTasks.length > 0) {
        let task = data.partnerTasks[0]

        this.task = task
        callback(task)
      } else {
        console.log('Nothing from query')
      }
    })
  }

  @action loadtaskPriorities() {
    this.ds.query(`{ taskPriorities(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.taskPriorities
    })
  }

  @action loadTaskStates() {
    this.ds.query(`{ taskStates(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.taskStates = data.taskStates
    })
  }

  @action newTask(name) {
  }

  @action updateTask(row, callback) {
    let query = `mutation { updateTask(
      id: ${ row.id },
      assignedUserId: ${ row.assignedUserId },
      newAssigned: ${ row.newAssigned },
      task: "${ row.task }",
      taskPriorityId: ${ row.taskPriorityId },
      taskStateId: ${ row.taskStateId },
      dueDate: "${ row.dueDate }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action updateTaskDuedate(row, callback) {
    const query = `mutation { updateTask(
      id: ${ row.id },
      dueDate: "${ row.dueDate }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action updatePartnerTaskDuedate(row, callback) {
    const query = `mutation { updatePartnerTask(
      id: ${ row.id },
      dueDate: "${ row.dueDate }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action updateTaskAssignedUser(row, callback) {
    const query = `mutation { updateTask(
      id: ${ row.id },
      assignedUserId: ${ row.assignedUserId },
      newAssigned: ${ row.newAssigned },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action updatePartnerTaskAssignedUser(row, callback) {
    const query = `mutation { updatePartnerTask(
      id: ${ row.id },
      assignedUserId: ${ row.assignedUserId },
      newAssigned: ${ row.newAssigned },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action deleteTask(id, callback) {
    this.ds.query(`mutation { deleteTask(
      id: ${ id },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action updatePartnerTask(row, callback) {
    let query = `mutation { updatePartnerTask(
      id: ${ row.id },
      assignedUserId: ${ row.assignedUserId },
      newAssigned: ${ row.newAssigned },
      task: "${ row.task }",
      taskPriorityId: ${ row.taskPriorityId },
      taskStateId: ${ row.taskStateId },
      dueDate: "${ row.dueDate }",
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`
    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action deletePartnerTask(id, callback) {
    this.ds.query(`mutation { deletePartnerTask(
      id: ${ id },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id } }`, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }
}

export default new Tasks()



// WEBPACK FOOTER //
// ./src/stores/tasks.js